import { IApplicationState } from '../../types/redux';
import { format, isValid, parseISO } from 'date-fns';

export function getNews(state: IApplicationState) {
  if (state.fsk?.news) {
    return state.fsk.news.map((item, index) => {
      const parsedDate = parseISO(item.date);

      return {
        id: index,
        title: item.text,
        date: isValid(parsedDate) ? format(parseISO(item.date), 'dd.MM.yy') : '',
      };
    });
  }

  return state.developer.news;
}
